import React from 'react';

function BackgroundVideo({ src = 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', poster = '/images/arcade-poster.svg', mobilePoster = '/images/arcade-poster-mobile.jpg' }) {
  // Show the same video on all screens per request. Keep poster for fallback.
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      <video
        className="w-full h-full object-cover min-w-[100%] min-h-[100%]"
        src={src}
        poster={poster}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        aria-hidden="true"
      />

      {/* subtle dark overlay to keep foreground readable */}
      <div className="absolute inset-0 bg-black/50 pointer-events-none sm:bg-black/40" />
    </div>
  );
}

export default BackgroundVideo;
